import { ComponentProps, FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '../../components';
import TFSIcon from '../../icons/Tfs.icon';
import { StyledBenefitsSection } from './BenefitsSection.styled';
import BenefitCard from './components/BenefitCard';

const benefits: ComponentProps<typeof BenefitCard>[] = [
  {
    title: 'ced-why-block1-title',
    description: 'ced-why-block1-copy',
    icon: <Icon name="calendar-days" />,
  },
  {
    title: 'ced-why-block2-title',
    description: 'ced-why-block2-copy',
    icon: <Icon name="steering-wheel" />,
  },
  {
    title: 'ced-why-block3-title',
    description: 'ced-why-block3-copy',
    icon: <Icon name="car-side" />,
  },
  {
    title: 'ced-why-block4-title',
    description: 'ced-why-block4-copy',
    icon: <Icon name="coins" />,
  },
  {
    title: 'ced-why-block5-title',
    description: 'ced-why-block5-copy',
    icon: <Icon name="car-garage" />,
  },
  {
    title: 'ced-why-block6-title',
    description: (
      <span className="google-stars-review">
        <span className="google-stars-grade" aria-hidden="true">
          4.7
        </span>
        <span aria-label="Rated 4.7 out of 5," role="img">
          <span aria-hidden="true">
            <span
              className="google-stars"
              style={{
                background:
                  'linear-gradient(to right, currentcolor 62px, #dadce0 0%)',
              }}
            ></span>
          </span>
        </span>
        <span className="google-stars-quantity">(90,000+)</span>
      </span>
    ),
    icon: <TFSIcon />,
  },
];

const BenefitsSection: FC = () => {
  const { t } = useTranslation();

  return (
    <StyledBenefitsSection
      title={t('ced-why-title')}
      className="cedolauto-benefits-section"
      variant="dark"
    >
      <div className="cedolauto-benefits-section__cards">
        {benefits.map(({ description, icon, title }) => (
          <BenefitCard
            key={title}
            title={title}
            description={description}
            icon={icon}
          />
        ))}
      </div>
    </StyledBenefitsSection>
  );
};

export default BenefitsSection;
